import { render, staticRenderFns } from "./GeneralStatistics.vue?vue&type=template&id=0183cdec&scoped=true"
import script from "./GeneralStatistics.vue?vue&type=script&lang=js"
export * from "./GeneralStatistics.vue?vue&type=script&lang=js"
import style0 from "./GeneralStatistics.vue?vue&type=style&index=0&id=0183cdec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0183cdec",
  null
  
)

export default component.exports